import { statusAdapter } from '../adapters/common/status-adapter';
import { devBoxAddOnsAdapter } from '../adapters/dev-box-add-ons-adapters';
import { StoreState } from '../store/store-state';
import { createMapFromEntitiesSelector } from './common';

/**
 * Entity state selectors
 */

const devBoxAddOnSelectors = devBoxAddOnsAdapter.getSelectors<StoreState>(
    (store) => store.addOnsStore.data.devBoxAddOns
);

const statusesForListAddOnsSelectors = statusAdapter.getSelectors<StoreState>(
    (store) => store.addOnsStore.status.listDevBoxAddOns
);

/**
 * Composed selectors
 */

export const getAddOnsByDevBoxId = createMapFromEntitiesSelector(devBoxAddOnSelectors.selectAll);

export const getStatusesForListAddOnsByDevBoxId = createMapFromEntitiesSelector(
    statusesForListAddOnsSelectors.selectAll
);
